import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useInView } from 'react-intersection-observer';

function withLazyLoading(Component, options) {
    const { rootMargin ='150px 0px' , className , classNameAfterLoad ='' , classNameBeforeLoad ='' , ['data-t']: dataT ,  } = options || {};
    const wrappedName = Component.displayName || Component.name || 'Component';
    const withLazyLoading1 = (props)=>{
        const [inViewRef, inView] = useInView({
            rootMargin,
            triggerOnce: true
        });
        const containerClassName = classnames('lazy-loading', className, [
            {
                [`${classNameBeforeLoad}`]: !inView,
                [`${classNameAfterLoad}`]: inView
            }, 
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            className: containerClassName,
            ref: inViewRef,
            "data-t": dataT
        }, inView ? /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props)) : null);
    };
    withLazyLoading1.displayName = `WithLazyLoading(${wrappedName})`;
    return withLazyLoading1;
}

export { withLazyLoading };
//# sourceMappingURL=with-lazy-loading.js.map
